module.exports = __webpack_public_path__ + "static/media/close-arrow-accent.983037bc.svg";